import { Component, OnInit } from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { AnimationOptions } from 'ngx-lottie';
import { SpinnerService } from 'src/app/core/services/spinner.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css'],
  animations: [
    trigger('inOut', [
      state('in', style({ opacity: 1 })),
      transition(':enter', [style({ opacity: 0 }), animate('.1s')]),
      transition(':leave', [animate('.3s', style({ opacity: 0 }))]),
    ]),
  ],
})
export class SpinnerComponent implements OnInit {
  public options: AnimationOptions = {
    path: 'assets/animations/dashboard-spinner.json',
    loop: true,
    autoplay: true,
  };

  constructor(public spinnerService: SpinnerService) {}

  ngOnInit(): void {}
}
